import { render, staticRenderFns } from "./BaseEditor.vue?vue&type=template&id=422fee32&scoped=true&"
import script from "./BaseEditor.vue?vue&type=script&lang=js&"
export * from "./BaseEditor.vue?vue&type=script&lang=js&"
import style0 from "./BaseEditor.vue?vue&type=style&index=0&id=422fee32&prod&lang=css&"
import style1 from "./BaseEditor.vue?vue&type=style&index=1&id=422fee32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422fee32",
  null
  
)

export default component.exports